import { reduxForm } from 'redux-form';
import Joi from 'joi-full';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import FormTaxDetails from '../components/FormTaxDetails';
import { syncValidateData } from '../../../../common/validator';
import { TAXES_FORM_DETAILS } from '../constants';

const schema = Joi.object()
  .keys({
    id: Joi.string()
      .guid()
      .optional(),
    name: Joi.string()
      .min(2)
      .required(),
    percentage: Joi.number()
      .min(0)
      .max(100)
      .required(),
    addToPrice: Joi.boolean()
      .optional(),
    externalOrdersOnly: Joi.boolean()
      .optional(),
    enabled: Joi.boolean()
      .optional(),
  });

const validate = values => syncValidateData(values, schema);

const form = reduxForm({
  form: TAXES_FORM_DETAILS,
  enableReinitialize: true,
  destroyOnUnmount: false,
  validate,
});

export default compose(
  withRouter,
  form
)(FormTaxDetails);
